import { TextField } from "@mui/material";
import useStore from "hooks/useStore";
import { useEffect } from "react";
// Temporarily removed MUI date picker for deployment compatibility
// import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { isValidBirthdate } from "hooks/useFormHelpers";
import { useState } from "react";
import Skeleton from "react-loading-skeleton";

export default function StoreDateField({ type, name, required, label, fullWidth, ...props }) {
    const setPartialFormState = useStore((state) => state.setPartialFormState);
    const errors = useStore((state) => state.formErrors);
    const formState = useStore((state) => state.formState);
    const requiredFormFields = useStore((state) => state.requiredFormFields);
    const setRequiredFormField = useStore((state) => state.setRequiredFormField);
    const setDateFormField = useStore((state) => state.setDateFormField);
    const [valid, setValid] = useState(true);
    const student = useStore((state) => state.student);

    useEffect(() => {
        setRequiredFormField(name, required);
    }, [required, name, setRequiredFormField]);

    useEffect(() => {
        setDateFormField(name, true);
    }, [name, setDateFormField]);

    const onChange = (event) => {
        const date = event.target.value ? new Date(event.target.value) : null;
        setPartialFormState({ [name]: date });
        if (isValidBirthdate(date)) {
            setValid(true);
        }
    };

    const onBlur = () => {
        setValid(isValidBirthdate(formState[name]));
    };

    // Format date for input field (YYYY-MM-DD)
    const formatDateForInput = (date) => {
        if (!date) return "";
        const d = new Date(date);
        if (isNaN(d.getTime())) return "";
        return d.toISOString().split('T')[0];
    };

    return student ? (
        <TextField
            {...props}
            name={name}
            type="date"
            onChange={onChange}
            value={formatDateForInput(formState[name]) || ""}
            label={`${label}${requiredFormFields[name] ? " *" : ""}`}
            fullWidth={fullWidth}
            InputLabelProps={{ shrink: true }}
            error={!!errors[name] || !valid}
            helperText={
                !valid
                    ? `Date must be between 1900 and ${new Date().getFullYear() - 1}`
                    : errors[name]
                    ? "Please enter a valid date"
                    : ""
            }
            required={false}
            onBlur={onBlur}
        />
    ) : (
        <Skeleton height={59} width={props?.width} />
    );
}

StoreDateField.defaultProps = {
    required: false,
    fullWidth: false,
};
